<template>
  <BootstrapModal class="EditProductGroup" v-on="$listeners" @save="saveProductGroup">
    <div>
      <div class="form-group mb-2 d-flex align-items-start">
        <input type="checkbox" class="mt-1 mr-2" v-model="$v.is_global.$model" />
        <div>
          <span class="d-block font-weight-bold"> Global setting </span>
          <span class="d-block"> If enabled, the fields of this setting will be available for all products. </span>
        </div>
      </div>
      <FormInput class="form-element mb-3" v-model="$v.name.$model" id="supplier" label="Setting name" :vuelidate="$v"
        fieldName="name" />
      <label class="control-label">
        <span class="label">
          Fields
        </span>
      </label>
      <div class="content-wrapper card-wrapper">
        <div class="card raw-table-body">
          <div>
            <div class="table-content">
              <div class="ComposableTable d-flex">
                <table class="table w-full mb-0">
                  <thead>
                    <tr>
                      <th class="py-1 px-2 table-cell" width="30%">
                        LABEL
                      </th>
                      <th class="py-1 px-2 table-cell" width="40%">
                        DEFAULT VALUE
                      </th>
                      <th class="py-1 px-2 table-cell" width="30%">
                        TYPE
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in fields" :key="index">
                      <td width="30%">
                        <FormInput class="form-element" v-model="item.label" />
                      </td>
                      <td width="40%">
                        <FormInput class="form-element" v-model="item.value" />
                      </td>
                      <td width="30%">
                        <FormSelect style="width: 100%; margin: 0;" v-model="item.type" :options="types"></FormSelect>

                        <button @click="removeField(index)">
                          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.5 10.5L10.5 1.5M1.5 1.5L10.5 10.5" stroke="#6B7280" stroke-width="1.5"
                              stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <button type="button" class="btn btn-primary" @click="addField">
                          New Field
                        </button>
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template #title>
      {{ supplier ? "Edit settings" : "Create settings" }}
    </template>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "../BootstrapModal.vue"

import FormInput from "src/components/Inputs/FormInput.vue"
import FormSelect from "src/components/Inputs/FormSelect.vue"

import { required } from "vuelidate/lib/validators"

export default {
  props: ["supplier", "callback"],
  components: {
    BootstrapModal,
    FormInput,
    FormSelect
  },
  validations: {
    name: {
      required,
    },
    is_global: {
      
    }
  },
  data() {
    return {
      name: "",
      fields: [
        {
          label: "",
          value: "",
          type: "text"
        },
      ],
      types: [
        {
          value: "text",
          str: "Text"
        },
        {
          value: "boolean",
          str: "Boolean"
        },
        {
          value: "number",
          str: "Number"
        }
      ],
    }
  },
  created() {
    if (this.supplier) {
      this.$v.name.$model = this.supplier.name
      this.$v.is_global.$model = this.supplier.is_global
      this.fields = this.supplier.value
    }
  },
  methods: {
    addField() {
      this.fields.push({
        label: null,
        value: null,
        type: "text"
      })
    },
    removeField(index) {
      this.fields.splice(index, 1)
    },
    saveProductGroup() {
      this.$v.$touch()
      if (this.$v.$error) return;

      const payload = {
        name: this.$v.name.$model,
        is_global: this.$v.is_global.$model,
        value: this.fields
      }

      this.$handlePromise(async () => {
        if (this.supplier) {
          await this.axios.put(`/api/products/settings/${this.supplier.uid}`, payload)
        } else {
          await this.axios.post(`/api/products/settings`, payload)
        }

        this.$success("Product setting succesvol opgeslagen!")
        this.callback && this.callback()
        this.$emit("close")
      })
    },
  },
}

</script>

<style scoped>
.EditProductGroup {
  flex-basis: 700px;
}

.form-group {
  margin-bottom: unset !important
}
</style>
